import request from '@/utils/request'
const context = require('./context')

export function login(username, password) {
  return request({
    url: context.EEOP + '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: context.EEOP + '/admin/info',
    method: 'get',
  })
}

export function getUidInfo() {
  return request({
    url: context.EEOP + '/admin/generateUid',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: context.EEOP + '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: context.EEOP + '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: context.EEOP + '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: context.EEOP + '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: context.EEOP + '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: context.EEOP + '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: context.EEOP + '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: context.EEOP + '/admin/role/update',
    method: 'post',
    data: data
  })
}

export function changePasswd(data) {
  return request({
    url: context.EEOP + '/admin/updatePassword',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js